import React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HmiView, { HmiCrop, Outline } from './HmiView';
import { TARGET, pad } from './screenData';
import { fmt } from './translations';
import { Intro, Reveal } from './ui';
import { StudyText } from './studies';
import styles from './ScreenInspector.module.css';

// Study 04: on the Ready screen the pump says Off but its Auto Mode switch is green.
const PUMP = TARGET['overview.circulation_pump'].box;
const AUTO_SWITCH = [330, 410, 44, 24];

export default function WhyCrop({ t }) {
    const c = t.crop;
    return (
        <>
            <Intro eyebrow={c.eyebrow} title={c.title} sub={c.sub} />

            <div className={styles.duo}>
                <Reveal className={styles.duoItem} delay={0.1}>
                    <div className={styles.frame}>
                        <HmiView state="ready" label={c.whole}>
                            <Outline box={pad(AUTO_SWITCH, 8)} color="#F59E0B" width={3} animateBox={false} />
                        </HmiView>
                    </div>
                    <p className={styles.duoCaption}>{c.whole}</p>
                    <p className={styles.duoLabel}>{c.says}</p>
                    <p className={`${styles.duoAnswer} ${styles.bad}`}>
                        <CloseRoundedIcon sx={{ fontSize: 28 }} />“On”
                    </p>
                    <p className={styles.duoScore}>{fmt(c.score, { n: 13 })}</p>
                </Reveal>

                <Reveal className={styles.duoItem} delay={0.22}>
                    <div className={`${styles.frame} ${styles.frameCenter}`}>
                        <div className={styles.frameCrop}>
                            <HmiCrop state="ready" box={pad(PUMP, 4)} label={c.card} />
                        </div>
                    </div>
                    <p className={styles.duoCaption}>{c.card}</p>
                    <p className={styles.duoLabel}>{c.says}</p>
                    <p className={`${styles.duoAnswer} ${styles.good}`}>
                        <CheckRoundedIcon sx={{ fontSize: 28 }} />“Off”
                    </p>
                    <p className={styles.duoScore}>{fmt(c.score, { n: 17 })}</p>
                </Reveal>
            </div>

            <Reveal delay={0.3}><p className={styles.note}><StudyText text={c.note} /></p></Reveal>
        </>
    );
}
